import React, { useEffect, useState } from "react";
import Page from "./page";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import * as yup from 'yup'
import { useSnackbar } from 'notistack';
import { IconButton } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { actionOpenAddPerfilRol, actionRefreshTablePerfilesRol } from "../actionsRoles";
import { getAllPerfil } from "../../perfiles/requestPerfiles";
import { postPerfilesRol } from "../requestRoles";

export default function AgregarPerfilRol() {

  const dispatch = useDispatch();
  const notistack = useSnackbar();
  const { open, rol } = useSelector((state) => ({
    open: state.reducerRol.openAddPerfilRol,
    rol: state.reducerRol.rolSeleccionado
  }));
  const [perfiles, setPerfiles] = useState([]);
  const validationSchema = yup.object({
    // perfil: yup.string().required("Campo requerido"),
  });

  const formik = useFormik({
    initialValues: {
      perfil: ""
    },
    onSubmit: values => {
      const perfiles = values.perfil ? values.perfil.map(a => a._id) :[];
      const key = notistack.enqueueSnackbar("Guardando Perfil(es)...", {
        persist: true,
        anchorOrigin: {
          horizontal: "center",
          vertical: "bottom"
        }
      });
      try {
        postPerfilesRol(rol._id, perfiles)
          .then((response) => {
            if (response.status === 201) {
              notistack.closeSnackbar(key);
              const successkey = notistack.enqueueSnackbar("Operanción exitosa: perfiles guardados", {
                variant: 'success',
                anchorOrigin: {
                  horizontal: "center",
                  vertical: "bottom"
                },
                action: <IconButton onClick={() => notistack.closeSnackbar(successkey)}><Close /></IconButton>
              });
              dispatch(actionOpenAddPerfilRol());
              dispatch(actionRefreshTablePerfilesRol(true));
            } else {
              console.log(response);
              notistack.closeSnackbar(key);
              const errorkey = notistack.enqueueSnackbar("Error: No ha sido posible guardar los perfiles. Intente nuevamente y contacte con soporte el equipo de soporte", {
                variant: 'error',
                anchorOrigin: {
                  horizontal: "center",
                  vertical: "bottom"
                },
                action: <IconButton onClick={() => notistack.closeSnackbar(errorkey)}><Close /></IconButton>
              });
            }
          })
          .catch((e) => {
            console.log(e);
            notistack.closeSnackbar(key);
            const errorkey = notistack.enqueueSnackbar("Error: No ha sido posible guardar los perfiles. Contacte con soporte el equipo de soporte", {
              variant: 'error',
              anchorOrigin: {
                horizontal: "center",
                vertical: "bottom"
              },
              action: <IconButton onClick={() => notistack.closeSnackbar(errorkey)}><Close /></IconButton>
            });
          });

      }
      catch (e) {
        console.log(e);
        notistack.closeSnackbar(key);
        const errorkey = notistack.enqueueSnackbar("Error: No ha sido posible guardar los perfiles. Contacte con soporte el equipo de soporte", {
          variant: 'error',
          anchorOrigin: {
            horizontal: "center",
            vertical: "bottom"
          },
          action: <IconButton onClick={() => notistack.closeSnackbar(errorkey)}><Close /></IconButton>
        });
      }
    },
    validationSchema: validationSchema
  });

  const onClose = () => dispatch(actionOpenAddPerfilRol());

  const onEntered = () => {
    console.log(rol);
    if (rol) {
      getAllPerfil({})
        .then(response => {
          if (response.status === 200) {
            const perfiles = response.data;
            console.log(perfiles);
            const suggestions = [];
            for (let i = 0; i < perfiles.length; i++) {
              const option = { label: perfiles[i].nombre, value: i, _id: perfiles[i]._id };
              if (rol.perfiles && rol.perfiles.find(a => a._id === perfiles[i]._id)) continue;
              suggestions.push(option);
            }
            setPerfiles(suggestions);
          } else if (response.status === 204) {
            notistack.enqueueSnackbar("No hay perfiles cargados", {
              variant: 'warning',
              anchorOrigin: {
                horizontal: "center",
                vertical: "bottom"
              }
            });
            setPerfiles([]);
          } else {
            notistack.enqueueSnackbar("Error al cargar los perfiles. Intente de nuevo o contacte con soporte.", {
              variant: 'error',
              anchorOrigin: {
                horizontal: "center",
                vertical: "bottom"
              }
            });
            console.log(response);
          }
        })
        .catch(e => {
          console.log(e);
        });


    }
    formik.resetForm({
      perfil: "",
    });
  }

  return (
    <Page
      formik={formik}
      perfiles={perfiles}
      onClose={onClose}
      onEntered={onEntered}
      open={open}
    />
  );
}